'use strict';

import utils from './utils';
import hproLog from './log';

var notificationAPI = {
    permit: function () {
        return new Promise(function (resolve, reject) {
            if (notificationAPI.getPermission() == 'default') {
                // display dialog
                Notification.requestPermission(function (e) {
                    if (e != 'granted') {
                        utils.rejectWithReason(reject, 'not_granted', 'No permissions are granted')(notificationAPI.getPermission());
                    } else {
                        resolve(e);
                    }
                });
            } else if (getPermission() != 'granted') {
                utils.rejectWithReason(reject, 'not_granted', 'No permissions are granted')(notificationAPI.getPermission());
            }
            else {
                resolve();
            }
        });
    },
    isSupported: function () {
        if (!('serviceWorker' in navigator)) {
            hproLog.warn("Service workers are not supported by this browser");
            return false;
        }

        if (!('PushManager' in window)) {
            hproLog.warn('Push notifications are not supported by this browser');
            return false;
        }

        if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
            hproLog.warn('Notifications are not supported by this browser');
            return false;
        }

        return true;
    },

    getPermission: function () {
        if (!notificationAPI.isSupported()) {
            return false;
        }

        return Notification.permission;
    },

    isDenied: function () {
        var permission = notificationAPI.getPermission();
        if (!permission) {
            return true;
        }

        if (permission === 'denied') {
            hproLog.warn('Notifications are denied by the user');
            //            changePushButtonState('incompatible');
            return true;
        }

        return false;
    }
};

export default notificationAPI;


//////////////////
// WEBPACK FOOTER
// ./src/services/notification.js
// module id = 3
// module chunks = 0